import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { RESET_ALL_STAGING_DATA_MUTATION } from "./reset-all-staging-data-button.graphql";
import { Paths } from "../../../../routes/paths";
import { TREE_I18N_KEY, TREE_I18N_MAP } from "../../../../translations/tree";

export const ResetAllStagingDataButton = () => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();
	const [resetAllStagingData, isResettingAllStagingData] = useMutation(
		RESET_ALL_STAGING_DATA_MUTATION,
	);

	const handleOnClick = () => {
		resetAllStagingData({
			variables: {},
			onCompleted: () => {
				toast.success(
					t("staging.resetAllDataSuccess", {
						trees: TREE_I18N_MAP(TREE_I18N_KEY.treePlural),
					}),
				);
				navigate(
					Paths.educationalOffer.withId(btoa("TreeNode:regular-staging-course-root-id"))
						.path,
				);
			},
		});
	};

	return (
		<Button
			className={"mb-2"}
			label={t("staging.resetAllData", { trees: TREE_I18N_MAP(TREE_I18N_KEY.treePlural) })}
			disabled={isResettingAllStagingData}
			onClick={handleOnClick}
		/>
	);
};
